(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lookbook-drop"] && !Shopify.designMode) return;
  try {
    
class LookbookSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.lookbook__track');
    if (!this.track) return;

    this.nav   = this.querySelector('[data-lb-nav]');
    this.prev  = this.querySelector('[data-lb-prev]');
    this.next  = this.querySelector('[data-lb-next]');
    this.drag  = this.dataset.drag === 'true';
    this.moved = false;

    this._onScroll = this._raf(() => this._syncNav());
    this._onResize = this._raf(() => this._syncNav());

    this.track.addEventListener('scroll', this._onScroll, { passive: true });
    window.addEventListener('resize', this._onResize, { passive: true });

    if (this.prev) this.prev.addEventListener('click', () => this._step(-1));
    if (this.next) this.next.addEventListener('click', () => this._step(1));

    if (this.drag) this._bindDrag();

    if ('IntersectionObserver' in window) {
      this._io = new IntersectionObserver((entries) => {
        if (entries.some(e => e.isIntersecting)) { this._syncNav(); this._io.disconnect(); this._io = null; }
      }, { rootMargin: '200px' });
      this._io.observe(this);
    } else {
      this._syncNav();
    }
  }

  disconnectedCallback() {
    if (this.track) this.track.removeEventListener('scroll', this._onScroll);
    window.removeEventListener('resize', this._onResize);
    if (this._io) this._io.disconnect();
  }

  get isScroller() {
    return this.track.scrollWidth - this.track.clientWidth > 2;
  }

  _step(dir) {
    const card = this.track.firstElementChild;
    if (!card) return;
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    this.track.scrollBy({ left: dir * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
  }

  _syncNav() {
    if (this.drag) this.track.dataset.grab = this.isScroller ? 'true' : 'false';
    if (!this.nav) return;

    const active = this.isScroller;
    this.nav.hidden = !active;
    if (!active) return;

    const max = this.track.scrollWidth - this.track.clientWidth - 1;
    if (this.prev) this.prev.disabled = this.track.scrollLeft <= 1;
    if (this.next) this.next.disabled = this.track.scrollLeft >= max;
  }

  _bindDrag() {
    let startX = 0, startScroll = 0, active = false;

    const down = (e) => {
      if (e.pointerType !== 'mouse' || !this.isScroller) return;
      active = true;
      this.moved = false;
      startX = e.clientX;
      startScroll = this.track.scrollLeft;
      this.track.setPointerCapture(e.pointerId);
    };

    const move = (e) => {
      if (!active) return;
      const dx = e.clientX - startX;
      if (!this.moved && Math.abs(dx) > 4) {
        this.moved = true;
        this.track.classList.add('is-dragging');
      }
      if (this.moved) this.track.scrollLeft = startScroll - dx;
    };

    const up = (e) => {
      if (!active) return;
      active = false;
      this.track.classList.remove('is-dragging');
      try { this.track.releasePointerCapture(e.pointerId); } catch (_) {}
      if (this.moved) setTimeout(() => { this.moved = false; }, 0);
    };

    this.track.addEventListener('pointerdown', down);
    this.track.addEventListener('pointermove', move, { passive: true });
    this.track.addEventListener('pointerup', up);
    this.track.addEventListener('pointercancel', up);
    this.track.addEventListener('dragstart', (e) => e.preventDefault());
    this.track.addEventListener('click', (e) => {
      if (this.moved) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  }

  _raf(fn) {
    let ticking = false;
    return () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { fn(); ticking = false; });
    };
  }
}
if (!customElements.get('lookbook-slider')) customElements.define('lookbook-slider', LookbookSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
